export default "__VITE_PUBLIC_ASSET__3b086a77__"